import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StyleService } from '../../services/style/style.service';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent {
  // Inject style service
  protected styleService = inject(StyleService);

  // Input for diameter from parent component
  diameter = input<number>(50);
}
